import { Link } from "react-router-dom";
import { CONTACT, NAV_LINKS, LOGO_ICON } from "../data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[color:var(--bs-ink)] text-white pt-24 md:pt-32 pb-10"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="overline text-white/50">Base opérationnelle</div>
            <h3 className="font-display text-5xl md:text-6xl leading-[0.95] mt-6">
              Décoller.<br />
              <span className="text-[color:var(--bs-gold)] italic font-light">Depuis Namur.</span>
            </h3>
            <p className="mt-6 text-white/60 max-w-md font-light leading-relaxed">
              BSCOPTER opère depuis l'aérodrome de Namur et couvre l'ensemble de la Belgique. Vols de découverte, transports et missions sur mesure.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <div className="overline text-white/50 mb-6">Navigation</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/85 hover:text-[color:var(--bs-gold)] transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/cgv"
                  data-testid="footer-link-cgv"
                  className="text-white/85 hover:text-[color:var(--bs-gold)] transition-colors"
                >
                  Conditions générales
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-white/50 mb-6">Contact</div>
            <ul className="space-y-3 text-white/85">
              <li>
                <a
                  data-testid="footer-email"
                  href={`mailto:${CONTACT.email}`}
                  className="hover:text-[color:var(--bs-gold)] transition-colors"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-phone"
                  href={`tel:${CONTACT.phoneRaw}`}
                  className="hover:text-[color:var(--bs-gold)] transition-colors"
                >
                  {CONTACT.phone}
                </a>
              </li>
              <li className="text-white/60 pt-3 border-t border-white/10">{CONTACT.base}</li>
            </ul>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <img
              src={LOGO_ICON}
              alt=""
              className="h-10 w-10 object-contain bg-white p-1"
            />
            <div>
              <div className="overline text-white/60">BSCOPTER · {CONTACT.domain}</div>
              <div className="text-white/40 text-xs mt-1">
                © {new Date().getFullYear()} BSCOPTER. Tous droits réservés.
              </div>
            </div>
          </div>
          <div className="text-white/40 text-xs">
            Site design · Motion & craft
          </div>
        </div>
      </div>
    </footer>
  );
}
